import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Box, Grid, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import db, { firebase } from "../../firebase-config"
import { useParams } from 'react-router-dom'
import moment from 'moment-timezone';


const Root = styled(Box)({
  background: "#000",
  color: "#fff",
  width: "100%",
  height: "80vh",
  overflow: "hidden",
  padding: 16,
});

// Card for temperature boxes
const TempBox = styled(Box)(({ color, children }) => ({
  background: color,
  color: children === "NA" || children === "-" ? "transparent" : "#000",
  borderRadius: 6,
  width: "clamp(70px, 8vw, 110px)",
  height: "clamp(60px, 8vw, 90px)",
  fontSize: "clamp(18px, 3vw, 36px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: 600,
  fontSize: 36,
  lineHeight: 18,
  border: "1px solid #fff",
  padding: 3,
}));

// Right panel
const RightPanel = styled(Box)({
  background: "#bcd3cd",
  borderRadius: 12,
  padding: "16px 25px",
  height: 555,
  color: "#000",
});

const Label = styled(Typography)({
  fontWeight: 600,
  fontSize: 20,
});

export default function ProductionAirChillLine2() {
  const { line } = useParams();
  const [shift, setShift] = useState({});
  const [airChill, setAirChill] = useState([]);
  const [open, setOpen] = useState();
  const [addSprayWater, setAddSprayWater] = useState(null);
  const [data] = useState({
    coreTemp: "8:45",
    line: 1,
    lot: 156,
    sublot: 211,
    avgWeight: "2.1kg",
    output: "5°C",
    sprayWater: "6°C",
    line2Lower: {
      t1: "NA",
      t2: "NA",
      t3: "10°C",
      t4: "2°C",
      t5: "2°C",
      avg: "4°C",
    },
    line2Upper: {
      t1: "NA",
      t2: "NA",
      t3: "2°C",
      t4: "5°C",
      t5: "5°C",
      avg: "5°C",
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddSprayWater = (event) => {
    if (event.target.name === "spray_water") {
      setAddSprayWater(event.target.value);
    }
  };

  useEffect(() => {
    function updateShift() {
      const now = new Date();
      const hour = now.getHours();

      if (hour >= 6 && hour < 18) {
        // 06:00 - 17:59 → กลางวัน
        setShift({ SHIFT: "D" });
      } else {
        // 18:00 - 05:59 → กลางคืน
        setShift({ SHIFT: "N" });
      }
    }

    updateShift(); // เรียกครั้งแรกตอน mount

    const timer = setInterval(updateShift, 60 * 1000); // อัพเดททุก 1 นาที
    return () => clearInterval(timer); // clear ตอน unmount
  }, []);

  const handleSubmitAddSprayWater = async () => {
    try {
      // กำหนดชื่อ Collection และ Document
      const collectionName = "prod_mes_ignition_slaughter_airchill";
      const documentName = "thailand4071ck_koratgateway_0003LINE2SPRAY_WATER";

      // สร้าง Reference ไปยัง Document ใน Firestore
      const docRef = db.collection(collectionName).doc(documentName);

      // ตรวจสอบว่า add_target มีค่าหรือไม่
      if (!addSprayWater || isNaN(addSprayWater)) {
        alert("กรุณากรอก spray water เป็นตัวเลขที่ถูกต้อง!");
        return;
      }
      // สร้างข้อมูลสำหรับบันทึก
      const data = {
        TEMP: Number(addSprayWater), // เป้าหมายใหม่
        //REMAINING: remaining_target, // เป้าหมายที่เหลือ
        TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(), // เวลาบันทึก
      };

      // อัปเดตข้อมูลลง Firestore
      await docRef.set(data);

      // อัปเดต state และรีเซ็ต Dialog
      //alert("บันทึกเป้าหมายสำเร็จ!");
      setAddSprayWater(null);
      setOpen(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต spray water");
    }
  };

  useEffect(() => {
    const subscriberAirChill = db
      .collection("prod_mes_ignition_slaughter_airchill")
      .onSnapshot((querySnapshot) => {
        const airChillData = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
        }));
        setAirChill(airChillData);
      });
    return () => {
      subscriberAirChill();
    }
  }, []);

  const findMachine = (key) => (airChill || []).find((a) => (a?.MACHINE_NAME || "").includes(key)) || null;
  const findID = (key) => (airChill || []).find((a) => (a?.id || "").includes(key)) || null;
  /// left
  const tempguard_2d = findMachine("tempguard_2d");
  const tempguard_2c = findMachine("tempguard_2c");
  const tempguard_2b = findMachine("tempguard_2b");
  /// right
  const tempguard_31 = findMachine("tempguard_31");
  const tempguard_32 = findMachine("tempguard_32");
  const tempguard_33 = findMachine("tempguard_33");

  const spray_water = findID("thailand4071ck_koratgateway_0003LINE2SPRAY_WATER");
  const sensor_airchill02 = findID("thailand4070407040temp_sensorair_chill_sensorair chill2");

  const isExpiredTimestamp = (timestamp) => {
    if (!timestamp || typeof timestamp !== "string") return false;

    const parsed = new Date(timestamp.replace(" ", "T"));
    if (isNaN(parsed.getTime())) return false;

    const now = new Date();
    const diffMin = (now - parsed) / 1000 / 60;

    return diffMin > 20;  // true = หมดอายุ
  };

  const filterColor4Temp = (temp, timestamp) => {
    // ถ้า timestamp หมดอายุ → สีเทา
    if (isExpiredTimestamp(timestamp)) {
      return "#555";
    }

    const num = Number(temp);
    if (temp === "NA" || temp === "-" || temp === undefined || isNaN(num)) {
      return "#555";
    }

    return num > 4 ? "#f30f07" : "#a0e8a3";
  };

  const filterColor10Temp = (arg) => {
    const num = Number(arg);
    if (arg === "NA" || arg === "-" || arg === undefined || isNaN(num)) {
      return "#555";
    }
    if (num > 10) {
      return "#f30f07";
    }
    return "#a0e8a3";
  };

  const avgTemp = (...items) => {
    const valid = items
      .filter(i => i && !isExpiredTimestamp(i.timestamp))
      .map(i => Number(i.temp))
      .filter(v => !isNaN(v));

    if (valid.length === 0) return "-";

    return Math.round(valid.reduce((a, b) => a + b, 0) / valid.length);
  };

  const avgTempLeftValue = avgTemp(
    { temp: tempguard_2d?.TEMP, timestamp: tempguard_2d?.TIMESTAMP },
    { temp: tempguard_2c?.TEMP, timestamp: tempguard_2c?.TIMESTAMP },
    { temp: tempguard_2b?.TEMP, timestamp: tempguard_2b?.TIMESTAMP }
  );

  const avgTempRightValue = avgTemp(
    { temp: tempguard_31?.TEMP, timestamp: tempguard_31?.TIMESTAMP },
    { temp: tempguard_32?.TEMP, timestamp: tempguard_32?.TIMESTAMP },
    { temp: tempguard_33?.TEMP, timestamp: tempguard_33?.TIMESTAMP }
  );

  const displayTemp = (temp, timestamp) => {
    if (isExpiredTimestamp(timestamp)) return "";

    if (temp === undefined || temp === "-" || temp === "NA") return "";

    const num = Number(temp);
    if (isNaN(num)) return "";

    return Math.round(num) + "°C";
  };

  return (
    <>
      <HeaderCustom
        icon={
          shift?.SHIFT === "N" ? (
            <Tooltip title="กะ Night" arrow>
              <DarkModeOutlinedIcon style={{ color: "#ffffff" }} />
            </Tooltip>
          ) : (
            <Tooltip title="กะ Day" arrow>
              <LightModeOutlinedIcon style={{ color: "#ffffff" }} />
            </Tooltip>
          )
        }
        barWidth={6}
      >
        Air Chill (Room Temp) {line}
      </HeaderCustom>
      <Root>
        <Grid container spacing={2} >
          <Grid item xs={6}>
            {/* <Box display="flex" gap={1}> */}
            {/* <Box> */}
            <Grid container xs={12} sx={{ gap: 1.5 }}>
              <Grid
                container
                xs={6}
                spacing={0.8}
                display={"flex"}
                justifyContent={"center"}
                mb={"-8px"}
              >
                <Typography style={{ fontSize: 48, fontWeight: 600 }}>
                  {line} (ล่าง)
                </Typography>
              </Grid>
              <Grid
                container
                xs={6}
                spacing={0.8}
                display={"flex"}
                justifyContent={"center"}
                mb={"-8px"}
              >
                <Typography style={{ fontSize: 48, fontWeight: 600 }}>
                  {line} (บน)
                </Typography>
              </Grid>
              <Grid
                container
                xs={6}
                spacing={0.8}
                sx={{ border: "1px solid #adadad", padding: "0 13px 6px 0" }}
              >
                <Grid item xs={4}>
                  <TempBox color={"#555"}>

                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={"#555"}>

                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_2c?.TEMP, tempguard_2c?.TIMESTAMP)}>
                    {displayTemp(tempguard_2c?.TEMP, tempguard_2c?.TIMESTAMP)}
                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_2d?.TEMP, tempguard_2d?.TIMESTAMP)}>
                    {displayTemp(tempguard_2d?.TEMP, tempguard_2d?.TIMESTAMP)}
                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_2b?.TEMP, tempguard_2b?.TIMESTAMP)}>
                    {displayTemp(tempguard_2b?.TEMP, tempguard_2b?.TIMESTAMP)}
                  </TempBox>
                </Grid>
              </Grid>
              <Grid
                container
                xs={6}
                spacing={0.8}
                sx={{ border: "1px solid #adadad", padding: "0 13px 6px 0" }}
              >
                <Grid item xs={4}>
                  <TempBox color={'#555'}>

                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={'#555'}>

                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_32?.TEMP, tempguard_32?.TIMESTAMP)}>
                    {displayTemp(tempguard_32?.TEMP, tempguard_32?.TIMESTAMP)}
                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_31?.TEMP, tempguard_31?.TIMESTAMP)}>
                    {displayTemp(tempguard_31?.TEMP, tempguard_31?.TIMESTAMP)}
                  </TempBox>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <TempBox color={filterColor4Temp(tempguard_33?.TEMP, tempguard_33?.TIMESTAMP)}>
                    {displayTemp(tempguard_33?.TEMP, tempguard_33?.TIMESTAMP)}
                  </TempBox>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid
                item
                xs={6}
                mt={1}
                display={"flex"}
                alignItems="center"
                justifyContent={"center"}
                gap={1}
                sx={{ paddingLeft: "0 !important" }}
              >
                <Typography
                  style={{ fontSize: 36, fontWeight: 500 }}
                  sx={{ lineHeight: 1, textAlign: "center" }}
                >
                  Avg. <br />
                  Temp
                </Typography>
                <TempBox color={filterColor4Temp(avgTempLeftValue)}>
                  {avgTempLeftValue === undefined ||
                    avgTempLeftValue === null ||
                    avgTempLeftValue === "" ||
                    avgTempLeftValue === "-" ||
                    avgTempLeftValue === "NA"
                    ? ""
                    : `${avgTempLeftValue}°C`}
                </TempBox>
              </Grid>
              <Grid
                item
                xs={6}
                mt={1}
                display={"flex"}
                alignItems="center"
                justifyContent={"center"}
                gap={1}
                sx={{ paddingLeft: "0 !important" }}
              >
                <Typography
                  style={{ fontSize: 36, fontWeight: 500 }}
                  sx={{ lineHeight: 1, textAlign: "center" }}
                >
                  Avg. <br />
                  Temp
                </Typography>
                <TempBox color={filterColor4Temp(avgTempRightValue)}>
                  {avgTempRightValue === undefined ||
                    avgTempRightValue === null ||
                    avgTempRightValue === "" ||
                    avgTempRightValue === "-" ||
                    avgTempRightValue === "NA"
                    ? ""
                    : `${avgTempRightValue}°C`}
                </TempBox>
              </Grid>
              <Grid
                container
                display={"flex"}
                alignItems="center"
                justifyContent={"center"}
              >
                <Grid
                  item
                  xs={6}
                  mt={1}
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                  gap={1}
                >
                  <Typography
                    style={{ fontSize: 36, fontWeight: 500 }}
                    sx={{ lineHeight: 1, textAlign: "center" }}
                  >
                    Spray
                    <br />
                    Water
                  </Typography>
                  <Tooltip title="add spray water" arrow>
                    <TempBox color={filterColor10Temp(Math.round(spray_water?.TEMP))} onClick={handleClickOpen}>
                      {spray_water?.TEMP === undefined || spray_water?.TEMP === '-' || spray_water?.TEMP === 'NA' ? ' ' : Math.round(spray_water?.TEMP)}{spray_water?.TEMP === undefined || spray_water?.TEMP === '-' || spray_water?.TEMP === 'NA' ? ' ' : '°C'}
                    </TempBox>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Right side */}
          <Grid item xs={6}>
            <RightPanel>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#2d9281"
                borderRadius={6}
                p="4px 30px"
                mb={1}
              >
                <Label sx={{ color: "#000", fontSize: 48 }}>Core Temp</Label>
                <Typography style={{ fontSize: 48, fontWeight: 600 }}>
                  {moment(sensor_airchill02?.TIMESTAMP).format('HH:mm')} น.
                </Typography>
              </Box>

              <Typography
                style={{ fontSize: 48, fontWeight: 600 }}
                textAlign="center"
                mt={1}
              >
                {line}
              </Typography>

              <Box
                bgcolor="#89d4c1"
                borderRadius={3}
                // p={1}
                textAlign="center"
                mt={1}
                style={{ fontSize: 48, fontWeight: 600 }}
              >
                {sensor_airchill02?.LOT} - {sensor_airchill02?.SUBLOT}
                <Typography style={{ fontSize: 36 }} sx={{ mt: "-10px" }}>
                  Lot - Sublot
                </Typography>
              </Box>

              <Grid
                container
                mt={-1}
                display={"flex"}
                justifyContent={"center"}
                spacing={4}
              >
                <Grid
                  item
                  xs={4}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                >
                  <Typography style={{ fontSize: 40, fontWeight: 600 }} textAlign="center">
                    Avg.Weight
                  </Typography>
                  <TempBox
                    sx={{ height: 84, fontSize: 40, width: 130, color: '#000' }}
                    color={'#555'}
                  >
                    NA
                  </TempBox>
                </Grid>
                <Grid
                  item
                  xs={4}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                >
                  <Typography style={{ fontSize: 40, fontWeight: 600 }} textAlign="center">
                    Avg.Core Temp
                  </Typography>
                  <TempBox
                    sx={{ height: 84, fontSize: 40, width: 130, color: '#000' }}
                    color={filterColor4Temp(sensor_airchill02?.AVG_TEMP)}
                  >
                    {(Math.round(sensor_airchill02?.AVG_TEMP * 100) / 100).toFixed(1)} °C
                  </TempBox>
                </Grid>
              </Grid>
            </RightPanel>
          </Grid>
        </Grid>
      </Root>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Spray Water (°C)
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField

                fullWidth
                label="Spray Water (°C)"
                name="spray_water"
                required
                value={addSprayWater}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddSprayWater}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
          <Button disabled={!addSprayWater} onClick={() => { handleClose(false); handleSubmitAddSprayWater(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

